import * as Yup from "yup";

export const STUDENT_ID_LENGTH = 8;

export const companyBasicValidation = {
  companyName: Yup.string().required("Prosimo, vnesite ime podjetja."),
  companyLabel: Yup.string(),
  companyAddress: Yup.string().required("Prosimo, vnesite naslov podjetja."),
  companyCity: Yup.string().required("Prosimo, vnesite pošto podjetja."),
  companyZip: Yup.string()
    // .typeError("Poštna številka mora vsebovati le številke.")
    .required("Prosimo, vnesite poštno številko podjetja."),
  vatId: Yup.string()
    .typeError("Davčna številka mora vsebovati le številke.")
    .required("Prosimo, vnesite davčno številko."),
};

export const participantValidation = {
  firstName: Yup.string().required("Prosimo, vnesite ime udeleženca."),
  lastName: Yup.string().required("Prosimo, vnesite priimek udeleženca."),
  email: Yup.string()
    .email("E-pošta ni pravilno oblikovana.")
    .required("Prosimo, vnesite e-pošto udeleženca."),
};

export const contactPersonValidation = {
  contactFname: Yup.string().required("Prosimo, vnesite ime kontaktne osebe."),
  contactSname: Yup.string().required(
    "Prosimo, vnesite priimek kontaktne osebe"
  ),
  contactEmail: Yup.string()
    .email("E-pošta ni pravilno oblikovana.")
    .required("Prosimo, vnesite e-pošto kontaktne osebe."),
  contactPhone: Yup.string()
    // .matches(/^[0-9*#+-\s]+$/, "Telefonska številka ni pravilno oblikovana.")
    .required("Prosimo, vnesite telefonsko številko kontaktne osebe."),
};

export const studentValidation = Yup.object({
  firstName: Yup.string().required("Prosimo vnesite ime."),
  lastName: Yup.string().required("Prosimo, vnesite priimek."),
  email: Yup.string()
    .email("E-pošta ni pravilno oblikovana.")
    .required("Prosimo, vnesite e-pošto."),
  studentId: Yup.string()
    .required("Prosimo, vnesite vpisno številko.")
    .matches(/^[A-Za-z0-9]+$/, {
      message: "Vpisna številka lahko vsebuje samo črke in številke.",
      excludeEmptyString: true,
    })
    .length(
      STUDENT_ID_LENGTH,
      `Vpisna številka mora biti dolga ${STUDENT_ID_LENGTH} znakov.`
    ),
  studyYear: Yup.string()
    // .typeError("Letnik študija mora vsebovati le številke.")
    .required("Prosimo, vnesite letnik študija."),
});
